<script setup lang="ts">
import type { LocationQuery } from 'vue-router';

import UnifiedOnboardingFlow from '~/components/Unified/Onboarding/UnifiedOnboardingFlow.vue';
import { useConfigStore } from '~/stores/config';
import { readSignupHandoffEmail } from '~/utils/unified/signupHandoff';
import { parseSocialReturnFromQuery } from '~/utils/unified/socialReturn';

definePageMeta({
  authType: [AUTH_ROUTE_TYPE_GUEST],
  name: 'unified-login',
  layout: 'unified-public',
});
const { t } = useI18n();
useSeoMeta({
  title: t('unified.seo.login.title'),
});

const route = useRoute();
const configStore = useConfigStore();

// A consumer sign-up — a new email the card verified, or a new social account back from the
// provider — finishes in the Blinky flow without leaving /login. The schools card signs up itself.
const isSignupArrival = (query: LocationQuery) =>
  !configStore.isSchoolsCluster && (!!readSignupHandoffEmail(query) || !!parseSocialReturnFromQuery(query));

// Latched: the flow strips its hand-off params from the URL once it has read them.
const showSignup = ref(isSignupArrival(route.query));
watch(() => route.query, (query) => {
  if (isSignupArrival(query)) {
    showSignup.value = true;
  }
});
</script>

<template>
  <div
    v-if="showSignup"
    data-testid="signup-surface"
    class="fixed inset-0 z-50 overflow-y-auto bg-background"
  >
    <UnifiedOnboardingFlow />
  </div>
  <UnifiedAuthFlow v-else />
</template>
